export default {
    "data": {
        "h5": {
            "section": [
                { url: "https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/all_operate/mobile/%E5%85%A8%E6%A0%88%E8%BF%90%E8%90%A5%E5%AE%9E%E6%93%8D%E8%AE%AD%E7%BB%83%E8%90%A5%E2%80%94%E2%80%94H5%E5%A4%87%E4%BB%BD%402x.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20220120/1642666034847.jpg", type: "img" },
                { url: "https://s20.lgstatic.com/growth/activity/20211012/1634006838677.png", type: "btn", button_name: "评估我的薪资水平" },
                { url: "", type: "swiper", dataType: 0 },
                { url: "https://s20.lgstatic.com/growth/activity/20211012/1634006626361.png", type: "btn", button_name: "了解更多招聘信息" },
                { url: "https://s21.lgstatic.com/growth/activity/20211012/1634006799050.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20211012/1634006470148.png", type: "btn", button_name: "测测我适合吗？" },
                { url: "https://s20.lgstatic.com/growth/activity/20211012/1634007239030.png", type: "btn", smallBtn: true, button_name: "立即抢占试学名额" },
                { url: "https://s20.lgstatic.com/growth/activity/20211012/1634007299088.png", type: "img" },
                { url: "https://s21.lgstatic.com/growth/activity/20211012/1634023460149.png", type: "btn", smallBtn: true, button_name: "领取完整技能图谱" },
                { url: "https://s20.lgstatic.com/growth/activity/20211012/1634007646909.png", type: "btn", smallBtn: true, button_name: "立即匹配大厂私教" },
                { url: "https://s21.lgstatic.com/growth/activity/20211012/1634009094938.png", type: "btn", button_name: "领取完整课程大纲" },
                { url: "https://s20.lgstatic.com/growth/activity/20211012/1634009233367.png", type: "swiper", dataType: 1 },
                { url: "https://s21.lgstatic.com/growth/activity/20211012/1634010233006.png", type: "btn", smallBtn: true, button_name: "一键获取行业模版" },
                { url: "https://s20.lgstatic.com/growth/activity/20211012/1634010297186.png", type: "swiper", dataType: 2 },
                { url: "https://s21.lgstatic.com/growth/activity/20211012/1634010755289.png", type: "btn", smallBtn: true, button_name: "马上咨询" },
            ],
            "footerImg": "https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/all_operate/mobile/%E7%BC%96%E7%BB%84%208%402x.png",
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20211011/1633946743639.png",
                "https://s20.lgstatic.com/growth/activity/20211011/1633946755651.png"
            ],
            "swiperList2": [
                "https://s20.lgstatic.com/growth/activity/20211012/1634009630207.png",
                "https://s21.lgstatic.com/growth/activity/20211012/1634009649202.png",
                "https://s20.lgstatic.com/growth/activity/20211012/1634009665258.png",
                "https://s20.lgstatic.com/growth/activity/20211012/1634009677798.png"
            ],
            "swiperList3": [
                "https://s21.lgstatic.com/growth/activity/20211012/1634010387788.png",
                "https://s20.lgstatic.com/growth/activity/20211012/1634010401735.png",
                "https://s20.lgstatic.com/growth/activity/20211012/1634010413039.png"
            ],

        },
        "pc": {
            "imgObj": {
                "top": "https://s20.lgstatic.com/growth/activity/20211020/1634718101728.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210916/1631777323462.png",
                "section2": "https://s21.lgstatic.com/growth/activity/20210916/1631777336297.png",
                "section3": "https://s20.lgstatic.com/growth/activity/20210916/1631778356937.png",
                "section4": "https://s21.lgstatic.com/growth/activity/20210916/1631782003107.png",
                "section5": "https://s21.lgstatic.com/growth/activity/20210916/1631781995927.png",
                "btn_stage": "https://s21.lgstatic.com/growth/activity/20210916/1631778653597.png",
                "btn1": "https://s20.lgstatic.com/growth/activity/20210916/1631779326202.png",
                "logo": "https://s20.lgstatic.com/growth/activity/20210916/1631780433790.png",
                "footer": "https://s20.lgstatic.com/growth/activity/20210916/1631781988116.png",
            },
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631774961978.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631774969388.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631774975783.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631778024551.png",
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631779642120.png",
                "https://s20.lgstatic.com/growth/activity/20211126/1637915707850.jpg?x-oss-process=style/80",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779656394.png",
            ],
            "swiperList": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631774816400.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631774823928.png",
            ],
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631775063257.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631775070977.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631775077345.png",
            ],
            "swiperList2": [
                "https://s20.lgstatic.com/growth/activity/20210916/1631779015030.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779091541.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779100203.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779106757.png",
            ],
            "swiperList3": [
                "https://s21.lgstatic.com/growth/activity/20210916/1631779831927.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779838447.png ",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779859778.png",
                "https://s21.lgstatic.com/growth/activity/20210916/1631779866936.png",
                "https://s20.lgstatic.com/growth/activity/20210916/1631779874015.png"
            ]
        },
        "tabList": [
            { "stage": "职业发展" },
            { "stage": "学习模式" },
            { "stage": "课程体系" },
            { "stage": "就业服务" }
        ],

        "stageList": [
            {
                "stage": "第一阶段",
                "title": "运营基础篇",
                "teacher": "肖汀-9年+互联网运营经验。",
                "phaseTargetList": [
                    "清晰认知运营的核心工作内容与价值",
                    "理解运营思维和运营意识",
                    "能根据运营能力模型匹配运营求职目标",
                ],
                "skillsList": [
                    "全方位了解运营工作流程全貌",
                    "分类解读运营岗位及核心能力",
                    "底层能力：运营意识和运营思维"
                ],
                "applycation": "设定目标运营岗位，根据能力要求，制定对应的能力提升目标和求职规划",
                "details": [
                    {
                        "t": "一、 全方位了解运营工作流程全貌",
                        "desc": [
                            "运营的概念理解",
                            "运营的价值创造：流量、收入、用户LTV",
                            "运营的功能：与产品、市场营销的区别"
                        ]
                    },
                    {
                        "t": "二、 分类解读运营岗位及核心能力",
                        "desc": [
                            "看清运营岗位的工作全貌",
                            "不同运营岗位职能和关键指标",
                            "不同运营岗的核心能力要求"
                        ]
                    },
                    {
                        "t": "三、 底层能力：运营意识和运营思维",
                        "desc": [
                            "两大运营意识：目标导向和二八效率",
                            "四大运营思维：用户思维、流程化、聚类分层、拆解思维"
                        ]
                    }
                ]
            },
            {
                "stage": "第二阶段",
                "title": "活动运营篇",
                "teacher": "张小坏-人人都是产品经理、鸟哥笔记专栏作者。",
                "phaseTargetList": [
                    "能够独立完成实现业务增长的活动策划方案撰写",
                    "具备推动活动落地执行、帮助业务实际带来增长的能力"
                ],
                "skillsList": [
                    "导论：活动运营全知",
                    "策划：定义目标，确立主题",
                    "流程：紧盯目标，抓好关键",
                    "推广：营销造势，爆款预热",
                    "执行：理顺清单，步步落实",
                    "复盘：报告总结，经验迭代"
                ],
                "applycation": "为目标产品策划一场实现业务增长的活动，撰写完成活动策划方案",
                "details": [
                    {
                        "t": "一、导论：活动运营全知",
                        "desc": [
                            "活动运营的三种目的",
                            "如何评价一场活动的优劣",
                            "活动运营的工作流程全貌"
                        ]
                    },
                    {
                        "t": "二、策划：定义目标，确立主题",
                        "desc": [
                            "常见的活动目的及活动形式",
                            "如何定义活动目标",
                            "活动主题的作用及撰写思路"
                        ]
                    },
                    {
                        "t": "三、流程：紧盯目标，抓好关键",
                        "desc": [
                            "常见活动类型的活动流程",
                            "梳理用户故事地图，找到活动关键事项"
                        ]
                    },
                    {
                        "t": "四、推广：营销造势，爆款预热",
                        "desc": [
                            "活动推广渠道和推广方式",
                            "四大维度找准推广卖点",
                            "制作活动推广物料"
                        ]
                    },
                    {
                        "t": "五、执行：理顺清单，步步落实",
                        "desc": [
                            "如何做好活动执行",
                            "梳理活动关键执行事项"
                        ]
                    },
                    {
                        "t": "六、复盘：报告总结，经验迭代",
                        "desc": [
                            "活动复盘的目的与作用",
                            "活动复盘报告的格式及撰写技巧",
                            "基于活动经验形成标准化流程（SOP）"
                        ]
                    }
                ]
            },
            {
                "stage": "第三阶段",
                "title": "内容运营篇",
                "teacher": "郭谊-阿里高级产品运营专家(P8)",
                "phaseTargetList": [
                    "清楚内容运营的价值和内容运营产出方式",
                    "掌握UGC和PGC内容产出模式的优劣势和运营方法",
                    "学会撰写运营文案，通过文案实现各项运营指标"
                ],
                "skillsList": [
                    "导论：内容运营的发展",
                    "内容产出：模式变迁和多元应用",
                    "巧用算法，最大化内容推送价值",
                    "创新：长盛不衰的内容运营法则",
                    "内容运营的收益评估和风险控制",
                    "重新理解运营和文案",
                    "四步写出优秀运营文案"
                ],
                "applycation": "根据不同产品、运营目标和内容场景完成对应的文案撰写任务",
                "details": [
                    {
                        "t": "一、导论：内容运营的发展",
                        "desc": [
                            "内容运营在不同产品中的定义和价值",
                            "内容运营与新媒体运营的职能区别"
                        ]
                    },
                    {
                        "t": "二、内容产出：模式变迁和多元应用",
                        "desc": [
                            "变迁：Web1.0/2.0/3.0的内容产出模式",
                            "两大模式：UGC和PGC的定义和优劣势",
                            "案例：抖音如何结合UGC和PGC做内容运营"
                        ]
                    },
                    {
                        "t": "三、巧用算法，最大化内容推送价值",
                        "desc": [
                            "自动推荐：热度算法和个性化算法",
                            "内容运营如何做好每一条push"
                        ]
                    },
                    {
                        "t": "四、创新：长盛不衰的内容运营法则",
                        "desc": [
                            "三大创新关键：场景化、个性化、流程化"
                        ]
                    },
                    {
                        "t": "五、内容运营的收益评估和风险控制",
                        "desc": [
                            "内容运营的短期收益和长期收益",
                            "内容运营的风险，如何预防和把控？"
                        ]
                    },
                    {
                        "t": "六、重新理解运营和文案",
                        "desc": [
                            "运营人的文案能力要求和运用场景",
                            "运营文案与普通文案的写作区别",
                            "运营新人如何进阶成文案高手"
                        ]
                    },
                    {
                        "t": "七、四步写出优秀运营文案",
                        "desc": [
                            "撰写吸引用户的标题",
                            "用文案激发用户好奇心",
                            "靠文案赢得用户信任",
                            "用文案引导用户下单和使用"
                        ]
                    }
                ]
            },
            {
                "stage": "第四阶段",
                "title": "产品运营篇",
                "teacher": "郭谊-阿里高级产品运营专家(P8)",
                "phaseTargetList": [
                    "建立正确的产品运营底层认知",
                    "学会制定产品运营目标和运营策略",
                    "具备对内产品需求管理和对外产品推广能力"
                ],
                "skillsList": [
                    "导论：产品运营的基本概念",
                    "核心：产品生命周期及运营策略",
                    "对内：精准判断，管理产品需求",
                    "对外 ：选对渠道，做好产品推广"
                ],
                "applycation": "选择一个产品绘制产品生命周期曲线，分析运营目标和运营策略，填写产品需求输入表",
                "details": [
                    {
                        "t": "一、导论：产品运营的基本概念",
                        "desc": [
                            "产品运营的工作内容和价值",
                            "产品运营和其他运营的关系",
                            "产品运营和产品团队的关系",
                            "产品运营的专业能力和通用能力"
                        ]
                    },
                    {
                        "t": "二、核心：产品生命周期及运营策略",
                        "desc": [
                            "产品的生命周期和曲线解读",
                            "判断产品生命周期的标准",
                            "不同产品生命周期的运营目标和策略"
                        ]
                    },
                    {
                        "t": "三、对内：精准判断，管理产品需求",
                        "desc": [
                            "什么是产品需求管理？",
                            "判断产品需求层级：Kano模型",
                            "产品需求管理在不同生命周期的侧重点"
                        ]
                    },
                    {
                        "t": "四、对外 ：选对渠道，做好产品推广",
                        "desc": [
                            "产品推广和USP",
                            "产品运营如何有效提炼USP",
                            "产品运营如何确定推广方案？",
                            "如何筛选和确定产品推广渠道"
                        ]
                    },
                ]
            },
            {
                "stage": "第五阶段",
                "title": "用户运营篇",
                "teacher": "肖汀-9年+互联网运营经验。",
                "phaseTargetList": [
                    "熟悉用户运营全景，建立用户运营的底层认知",
                    "深入学习AARRR模型，拓展全流程运营视角",
                    "系统学习用户成长体系搭建方法论，掌握精细化运营精髓",
                    "掌握不同产品流量阶段的用户运营策略"
                ],
                "skillsList": [
                    "导论：用户运营全景",
                    "用户运营的AARRR模型",
                    "搭建用户成长激励体系",
                    "精细化运营1：用户分层模型",
                    "精细化运营2：用户补贴的价值"
                ],
                "applycation": "选择一个产品绘制产品生命周期曲线，分析运营目标和运营策略，填写产品需求输入表",
                "details": [
                    {
                        "t": "一、导论：用户运营全景",
                        "desc": [
                            "用户运营在企业中的重要意义",
                            "用户运营常见能力模型",
                            "用户运营的就业分析和职业发展路径",
                        ]
                    },
                    {
                        "t": "二、用户运营的AARRR模型",
                        "desc": [
                            "用户运营角度认识AARRR模型",
                            "案例：不同行业和产品的AARRR模型应用",
                            "用好工具，检视AARRR模型"
                        ]
                    },
                    {
                        "t": "三、搭建用户成长激励体系",
                        "desc": [
                            "用户成长激励体系底层逻辑",
                            "用户成长激励体系搭建三步法",
                            "案例：头部互联网公司用户成长体系设计方案"
                        ]
                    },
                    {
                        "t": "精细化运营1：用户分层模型",
                        "desc": [
                            "用户分层和用户分群的重要性",
                            "用户生命周期和分层模型",
                            "产品运营如何确定推广方案？",
                            "分层模式：RFM分层模型和其他"
                        ]
                    },
                    {
                        "t": "五、精细化运营2：用户分层模型",
                        "desc": [
                            "如何补贴用户实现拉新引流",
                            "如何用补贴引导激活转化",
                            "如何用补贴促进持续消费和召回"
                        ]
                    }
                ]
            },
            {
                "stage": "第六阶段",
                "title": "数据运营篇",
                "teacher": "磊叔-11年数据工作经验。",
                "phaseTargetList": [
                    "拥有数据思维，能够用数据优化运营策略",
                    "学习数据指标，掌握数据指标制定方法",
                    "对Spark Streaming、Spark GraphX等进行讲解",
                    "掌握用分析模型法进行数据分析"
                ],
                "skillsList": [
                    "导论：全面认识数据运营 ",
                    "掌握指标体系，为业务设计正确指标",
                    "准确分析业务，从指标洞察业务问题",
                    "理解数据分析结果，洞察业务增⻓策略"
                ],
                "applycation": "选择一个熟悉的产品，梳理其指标体系，分析制定产品的运营数据",
                "details": [
                    {
                        "t": "一、导论：全面认识数据运营",
                        "desc": [
                            "数据运营的工作内容",
                            "数据运营与其他运营的关系与区别 ",
                            "数据运营的职业发展通道",
                            "数据运营四大核心工作流程"
                        ]
                    },
                    {
                        "t": "二、掌握指标体系，为业务设计正确指标",
                        "desc": [
                            "指标体系的定义和8大组成要素",
                            "指标“陷阱”1:北极星指标和虚荣指标 ",
                            "指标“陷阱”2:先导型指标和滞后型指标 ",
                            "如何建设科学的指标体系和评价机制"
                        ]
                    },
                    {
                        "t": "三、准确分析业务，从指标洞察业务问题 ",
                        "desc": [
                            "如何分析用户特征",
                            "如何分析业务流程",
                            "如何分析业务指标"
                        ]
                    },
                    {
                        "t": "四、理解数据分析结果，洞察业务增⻓策略",
                        "desc": [
                            "3A3R模型的定义、应用场景和使用方法",
                            "正确使用3A3R模型有效获客-留存-变现",
                            "用私域和裂变手段构建增长护城河"
                        ]
                    }
                ]
            },
            {
                "stage": "第七阶段",
                "title": "社群运营篇",
                "teacher": "考拉-考拉新媒体导航、葡萄商学院创始人。",
                "phaseTargetList": [
                    "可以判断社群的必要性和标准，能够分析社群底层的商业逻辑",
                    "掌握三大类型社群设计的标准、用户获取的主流玩法和运营手段",
                    "理解社群与私域的关系，能通过社群玩转私域流量的转化变现"
                ],
                "skillsList": [
                    "导论：社群运营认知",
                    "实战玩法1：流量型社群",
                    "实战玩法2：组织型社群",
                    "实战玩法3：转化型社群"
                ],
                "applycation": "为目标企业和产品选择一种合适的社群运营模式，并以转化为目标设计一套完整的社群方案",
                "details": [
                    {
                        "t": "一、导论：社群运营认知",
                        "desc": [
                            "社群的几种模式",
                            "做社群前必须知道的几个问题",
                            "三种主流社群形态和模式"
                        ]
                    },
                    {
                        "t": "二、实战玩法1：流量型社群",
                        "desc": [
                            "流量型社群如何获取用户",
                            "流量型群内如何做运营"
                        ]
                    },
                    {
                        "t": "三、实战玩法2：组织型社群",
                        "desc": [
                            "组织型社群的特质和六大要素",
                            "组织型社群如何获取用户",
                            "组织型社群的运营管理方法"
                        ]
                    },
                    {
                        "t": "四、实战玩法3：转化型社群",
                        "desc": [
                            "社群运营的转化模型设计",
                            "社群转化SOP的设计和生产",
                            "精细化运营，提升社群转化率",
                            "运营管理：带领一群人做好转化"
                        ]
                    }
                ]
            },
            {
                "stage": "第八阶段",
                "title": "新媒体运营篇",
                "teacher": "张小坏-人人都是产品经理、鸟哥笔记专栏作者。",
                "phaseTargetList": [
                    "清楚新媒体运营的工作范畴和价值",
                    "熟悉账号搭建、内容生产发布、增长运营各流程",
                    "了解新媒体矩阵运营、多平台运营的策略和玩法"
                ],
                "skillsList": [
                    "导论：新媒体运营概述",
                    "公众号篇（上）：内容生产",
                    "公众号篇（下）：增长运营",
                    "小红书篇：打造爆款笔记",
                    "知乎篇：高质量引流"
                ],
                "applycation": "选择一个从0到1搭建新媒体账号，并根据定位和内容调性生产至少一篇有效内容",
                "details": [
                    {
                        "t": "一、导论：新媒体运营概述",
                        "desc": [
                            "新媒体运营的定义和职能",
                            "新媒体人的技能成长和职业发展"
                        ]
                    },
                    {
                        "t": "二、公众号篇（上）——内容生产",
                        "desc": [
                            "定位：明确用户画像和内容调性",
                            "选题：九宫格选题法和热点选题法",
                            "素材：如何做好信息收集和捕捉",
                            "排版：新手必学的排版工具和原则",
                            "内容：标题技巧、文章结构、配图规范"
                        ]
                    },
                    {
                        "t": "三、公众号篇（下）——增长运营",
                        "desc": [
                            "内容驱动：处处可用的内容涨粉操作",
                            "资源驱动：掌握互推套路实现联合增长",
                            "打造爆款：依靠传播和裂变驱动的增长"
                        ]
                    },
                    {
                        "t": "四、小红书篇——打造爆款笔记",
                        "desc": [
                            "小红书用户画像和内容特点",
                            "账号定位及笔记撰写技巧",
                            "如何打造爆款笔记快速涨粉",
                            "关键词排名优化和引流策略"
                        ]
                    },
                    {
                        "t": "五、知乎篇——高质量引流",
                        "desc": [
                            "熟悉知乎平台和机构号建立机制",
                            "机构号如何快速获得曝光和关注度",
                            "适合机构号的知乎引流策略",
                            "运营机构号必备的避坑指南"
                        ]
                    }
                ]
            },
            {
                "stage": "第九阶段",
                "title": "短视频运营篇",
                "teacher": "向前-前抖音电商商家成长负责人。",
                "phaseTargetList": [
                    "了解短视频的变现方式和玩法",
                    "学会账号定位和搭建，做好账号前期筹备",
                    "掌握视频制作全流程，生产高传播量短视频",
                    "熟悉平台机制和流量算法，掌握投放工具，实现涨粉变现"
                ],
                "skillsList": [
                    "应变：视频赛道，运营人如何乘风而上",
                    "账号定位：战略领先，多位一体冷启动",
                    "视频生产：编写拍剪，即学即用硬技能",
                    "运营增长：有数有据，用算法引爆流量"
                ],
                "applycation": "拆解热门短视频账号，总结输出调研报告；从零搭建一个短视频账号，根据定位完成一条短视频的拍摄制作和发布",
                "details": [
                    {
                        "t": "一、应变：视频赛道，运营人如何乘风而上",
                        "desc": [
                            "传统传播逻辑失效，短视频已成风口",
                            "视频算法时代对运营新人的技能要求",
                            "短视频运营的相关岗位认知和职责"
                        ]
                    },
                    {
                        "t": "二、账号定位：战略领先，多位一体冷启动",
                        "desc": [
                            "账号定位：三步立好账号的人设和包装",
                            "账号筹备：账号人、货、服务、场准备",
                            "成长阶段：冷启动-成长-爆发-成熟期"
                        ]
                    },
                    {
                        "t": "三、视频生产：编写拍剪，即学即用硬技能",
                        "desc": [
                            "如何做好选题与视频脚本",
                            "如何仿拍热门视频之抖音梗",
                            "拍摄：设备准备和环境准备",
                            "剪辑：小白如何用剪映剪出爆款视频"
                        ]
                    },
                    {
                        "t": "四、运营增长：有数有据，用算法引爆流量",
                        "desc": [
                            "怎么样用网站上传高清晰度视频？",
                            "如何写好搞打开率的短视频标题",
                            "短视频运营必须关注的数据指标",
                            "搞懂平台机制，做好视频优化和投放"
                        ]
                    }
                ]
            },
            {
                "stage": "第十阶段",
                "title": "直播运营篇",
                "teacher": "向前-前抖音电商商家成长负责人。",
                "phaseTargetList": [
                    "清楚并能完整落地直播前准备",
                    "练好直播转化能力和产品服务承接能力",
                    "掌握投放工具，实现流量引入和卖货变现"
                ],
                "skillsList": [
                    "导论：变现直播间定位及配置",
                    "直播前必备：搭建、选品、话术",
                    "流量密码：有数有据打造爆款直播间"
                ],
                "applycation": "拆解一场爆款直播，分析各环节优缺点，行成总结报告",
                "details": [
                    {
                        "t": "一、导论：变现直播间定位及配置",
                        "desc": [
                            "解读四大类变现直播间的定位",
                            "直播间的团队配置及协作分工"
                        ]
                    },
                    {
                        "t": "二、直播前必备：搭建、选品、话术",
                        "desc": [
                            "如何用3000块搭出高品质直播间",
                            "直播如何进行选品、排品、组品设计",
                            "价值百万的直播间互动话术和成交话术"
                        ]
                    },
                    {
                        "t": "三、流量密码：有数有据打造爆款直播间",
                        "desc": [
                            "爆款秘诀：直播预告视频设计",
                            "投放工具：小店随心推/DOU+投放",
                            "高效投放：快速打标签，击穿流量池",
                            '数据复盘：直播后如何优化"人货场"'
                        ]
                    }
                ]
            },
            {
                "stage": "第十一阶段",
                "title": "ToB运营篇",
                "teacher": "张小坏-人人都是产品经理、鸟哥笔记专栏作者。",
                "phaseTargetList": [
                    "熟悉tob领域的几种典型形态，并清楚不同规模企业客户的运营策略",
                    "掌握tob运营的四大关键营销方法论和技能，每个环节都能独立输出方案文档"
                ],
                "skillsList": [
                    "导论：什么是 ToB 运营",
                    "ToB 运营的职业图谱",
                    "内容营销篇",
                    "活动营销篇",
                    "数字化营销篇",
                    "客户成功篇"
                ],
                "applycation": "完成一套ToB运营求职作品集，包含户成功案例、活动营销计划及客户成功方案",
                "details": [
                    {
                        "t": "一、导论：什么是ToB运营",
                        "desc": [
                            "互联网对ToB业务带来的变化",
                            "ToB领域下的三种典型业务形态",
                            "运营在ToB业务中的作用和价值",
                            "不同企业规模客户的运营策略"
                        ]
                    },
                    {
                        "t": "二、ToB运营的职业图谱",
                        "desc": [
                            "ToB运营岗位的工作理念：客户成功",
                            "ToB运营的岗位需求和能力要求",
                            "七步拿下满意的ToB运营offer"
                        ]
                    },
                    {
                        "t": "三、 内容营销篇",
                        "desc": [
                            "内容营销的作用和三大类型",
                            "如何撰写产品解决方案",
                            "如何撰写客户成功案例",
                            "如何产出行业白皮书"
                        ]
                    },
                    {
                        "t": "四、 活动营销篇",
                        "desc": [
                            "活动营销的作用和常见活动形式",
                            "如何基于热点制定活动营销日历",
                            "如何抓住突发热点进行活动营销"
                        ]
                    },
                    {
                        "t": "五、数字化营销篇",
                        "desc": [
                            "什么是数字化营销",
                            "有哪些常见的客户触点类型",
                            "如何建立有效的客户触点",
                            "基于客户触点的数字化营销应用"
                        ]
                    },
                    {
                        "t": "六、客户成功篇",
                        "desc": [
                            "什么是客户成功",
                            "建立批量化、标准化的客户服务方式",
                            "提升客户对产品的使用广度/深度",
                            "建立客户黏性，引导客户续费/转介绍"
                        ]
                    }
                ]
            },
            {
                "stage": "第十二阶段",
                "title": "运营求职篇",
                "teacher": "KiKi-笔试群面100%通过率保持者。",
                "phaseTargetList": [
                    "熟悉行业招聘趋势和流程，做好新人求职规划",
                    "掌握运营简历写作技巧，输出有竞争力的个人简历",
                    '拆解群面、单面"套路"，充分做好面试前准备'
                ],
                "skillsList": [
                    "掌握行业形势，做好求职规划",
                    "读懂用人需求，写出高分简历",
                    "条分缕析拆题，从容应对笔试",
                    "破解群面套路，轻松脱颖而出",
                    "单面各个击破，顺利通关offer"
                ],
                "applycation": "输出个人运营求职简历，完成大厂笔试真题练习，参与模拟面试",
                "details": [
                    {
                        "t": "一、掌握行业形势，做好求职规划",
                        "desc": [
                            "全方位解读互联网行业招聘趋势",
                            "校招三部曲：暑期实习-秋招-春招",
                        ]
                    },
                    {
                        "t": "二、读懂用人需求，写出高分简历",
                        "desc": [
                            "简历的功能、价值和筛选标准",
                            "七步写出优秀个人简历",
                            "拆解JD，精准匹配相关经历",
                            "写好求职信，提升通过率"
                        ]
                    },
                    {
                        "t": "三、条分缕析拆题，从容应对笔试",
                        "desc": [
                            "互联网校招笔试考情全解析",
                            "基础能力——认知能力测试",
                            "专业能力——职业能力测试",
                        ]
                    },
                    {
                        "t": "四、破解群面套路，轻松脱颖而出",
                        "desc": [
                            "群面的形式、流程、评分标准",
                            "群面的解题技巧和行为技巧"
                        ]
                    },
                    {
                        "t": "五、单面各个击破，顺利通关offer",
                        "desc": [
                            "单面的定义、形式和特点",
                            "九大面试中高频题破解思路",
                            "反向提问环节的应对技巧",
                            "面试跟踪、offer选择、薪资谈判"
                        ]
                    }
                ]
            }
        ]

    }
}
